import { render, staticRenderFns } from "./schedulesIndex.vue?vue&type=template&id=8895a4ec&"
import script from "./schedulesIndex.vue?vue&type=script&lang=js&"
export * from "./schedulesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports